import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'gymfinder-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  standalone: false,
})
export class FileUploadComponent {
  fileName: string;

  @Input()
  title: string;

  @Output()
  fileNameChanged = new EventEmitter<File>();

  public onFileSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files) {
      const file: File = target.files[0];

      if (file) {
        this.fileName = file.name;

        this.fileNameChanged.emit(file);
      }
    }
  }
}
